module.exports = __webpack_public_path__ + "img/servicepro_login.78457ffb.png";